import React from 'react';
import { TextField, FormHelperText, Box } from '@mui/material';

const JobNameField = ({ value, onChange, error, disabled, required }) => {
  const handleChange = (event) => {
    // Convert MUI event to Semantic UI-like format for compatibility
    const synthetic_event = {
      target: event.target,
      currentTarget: event.currentTarget,
    };
    onChange(synthetic_event, {
      name: 'job_name',
      value: event.target.value,
    });
  };

  const error_message =
    error && value === ''
      ? 'Job names cannot be blank'
      : error
        ? 'Job names cannot include the following characters: #$<>+%!`&*\'"|{}?/\\:=@'
        : '';

  return (
    <Box>
      <TextField
        name='job_name'
        label='Job Name'
        value={value || ''}
        required={required}
        onChange={handleChange}
        disabled={disabled}
        error={error}
        fullWidth
      />
      {error && error_message && (
        <FormHelperText error>{error_message}</FormHelperText>
      )}
    </Box>
  );
};

export default JobNameField;

